module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-new-outlet"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-form"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.label.name
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.form.name = $$v
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.place
    }
  }, [_c('gmap-autocomplete', {
    staticClass: "googlePlace",
    attrs: {
      "select-first-on-enter": true,
      "default-place": _vm.googlePlace
    },
    on: {
      "place_changed": _vm.updatePlace
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.country
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.form.country),
      callback: function($$v) {
        _vm.form.country = $$v
      },
      expression: "form.country"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.state
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.form.state),
      callback: function($$v) {
        _vm.form.state = $$v
      },
      expression: "form.state"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.city
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.form.city),
      callback: function($$v) {
        _vm.form.city = $$v
      },
      expression: "form.city"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.lng
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.form.lng),
      callback: function($$v) {
        _vm.form.lng = $$v
      },
      expression: "form.lng"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.lat
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.form.lat),
      callback: function($$v) {
        _vm.form.lat = $$v
      },
      expression: "form.lat"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.address1
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.address1),
      callback: function($$v) {
        _vm.form.address1 = $$v
      },
      expression: "form.address1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.address2
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.address2),
      callback: function($$v) {
        _vm.form.address2 = $$v
      },
      expression: "form.address2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.contact
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.contact),
      callback: function($$v) {
        _vm.form.contact = $$v
      },
      expression: "form.contact"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.phone
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.form.phone = $$v
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('Views.ViewOutletDetail.table.pt')
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.insideLoading),
      expression: "insideLoading"
    }],
    staticClass: "upload-photo",
    attrs: {
      "action": "/client/upload?type=photo",
      "show-file-list": false,
      "before-upload": _vm.beforePhotoUpload,
      "on-success": _vm.uploadInsidePhotoSuccess,
      "on-progress": _vm.uploadInsideProcess,
      "on-error": _vm.uploadInsidePhotoError
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Views.ViewOutletDetail.table.p1')))]), _vm._v(" "), (_vm.insidePhotoUrl !== '') ? _c('img', {
    staticClass: "shop-avatar",
    attrs: {
      "src": _vm.insidePhotoUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus shop-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.outsideLoading),
      expression: "outsideLoading"
    }],
    staticClass: "upload-photo",
    attrs: {
      "action": "/client/upload?type=photo",
      "show-file-list": false,
      "before-upload": _vm.beforePhotoUpload,
      "on-success": _vm.uploadOutsidePhotoSuccess,
      "on-progress": _vm.uploadOutsideProcess,
      "on-error": _vm.uploadOutsidePhotoError
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Views.ViewOutletDetail.table.p2')))]), _vm._v(" "), (_vm.outsidePhotoUrl !== '') ? _c('img', {
    staticClass: "shop-avatar",
    attrs: {
      "src": _vm.outsidePhotoUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus shop-uploader-icon"
  })])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.activeTime
    }
  }, _vm._l((_vm.weeks), function(item) {
    return _c('el-row', {
      key: item,
      staticClass: "sl-form-box-week"
    }, [_c('el-col', {
      staticClass: "week-name",
      attrs: {
        "span": 4,
        "xs": 12
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20,
        "xs": 12
      }
    }, [_c('el-input', {
      attrs: {
        "auto-complete": "off"
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          item.value = $$v
        },
        expression: "item.value"
      }
    })], 1)], 1)
  })), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success",
      "loading": _vm.btnLoading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('Button.save')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "el-button",
      "to": {
        name: 'Outlets'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.$ga.event('Link', 'Cancel', 'Add new store')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Button.cancel')))])], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-364f9f0b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/management/outlets/add-new-outlet.vue
// module id = 1096
// module chunks = 1